import { useQuery } from "@tanstack/react-query";
import { api } from "../singleton/axios";

export interface GeneralNewsArticle {
  title: string;
  url: string;
  publishedDate: string; // e.g., "2025-09-02 15:30:00"
  text: string;
  site: string;
  image?: string;
  symbol?: string; // May be null for general news
}

export interface GeneralNewsResponse {
  data: {
    articles: GeneralNewsArticle[];
    date: string; // YYYY-MM-DD
    totalArticles: number;
  };
}

interface ApiError {
  success: false;
  error: string;
  message?: string;
  details?: string;
}

// Get general stock news for current date
export const useGeneralNews = () => {
  return useQuery<GeneralNewsResponse, ApiError>({
    queryKey: ["generalNews"],
    queryFn: async () => {
      const { data } = await api.get<GeneralNewsResponse>("/general-news");
      return data;
    },
    refetchOnWindowFocus: false, // Don't refetch on focus to avoid excessive requests
    refetchInterval: 60 * 1000, // Auto-refetch every 1 minute for fresh news
    staleTime: 0, // Always consider data stale to allow interval refetching
    gcTime: 2 * 60 * 1000, // 2 minutes - keep in cache for 2 minutes
  });
};